import React from "react";
import Context from "../../../Context";
import Blocker from "../../Misc/Blocker";
import BsModal from "../../Misc/BsModal";
import DefaultNotFound from "../../Misc/DefaultNotFound";
import Jsonform from "../../Misc/Jsonform";

export default class TrackerSummaryAdd extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      pending: false,
      item: this.props.item,
      formData: {},

      fields: [],

      properties: [],
    };
  }

  componentDidMount() {
    this.load();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.tracker?.id !== this.props.tracker?.id) {
      this.load();
    }
    if (prevProps.item?.id !== this.props.item?.id) {
      this.load();
    }
  }

  onChange = (id, value) => {
    this.setState((state) => {
      let { item } = state;
      item[id] = value;
      return { item };
    });
  };

  onFormChange = (formData) => {
    this.setState({ formData });
  };

  getFields = async (filter) => {
    let fields = [];
    //Construct fileds
    let firstFields = await this.context.api.qa("/form/field/list", {
      filter,
      orderby: ["sequence ASC"],
    });

    let allFormsIDs = firstFields.reduce((v, f) => {
      let id = f.type === "subform" ? f.value : f.form;
      return !id || v.includes(id) ? v : [...v, id];
    }, []);

    let allFields = await this.context.api.qa("/form/field/list", {
      search: [
        {
          field: "form",
          valarr: allFormsIDs,
        },
      ],
      orderby: ["sequence ASC"],
    });

    firstFields.forEach((f) => {
      if (f.type === "subform") {
        f.subform = allFields.filter((sf) => sf.form === f.value);
      }
      fields.push(f);
    });
    return fields;
  };

  load = async () => {
    const { tracker, item } = this.props;
    this.setState({ pending: true });

    let fields = [];
    let formData = {};

    if (item?.id) {
      fields = item.form;
      formData = item.data;
    } else {
      fields = await this.getFields({ formcode: tracker.typecode });
    }

    this.setState({ pending: false, fields, formData });
  };

  save = async () => {
    const { item } = this.state;
    const { tracker } = this.props;

    this.setState({ pending: true });

    let resultItem = await this.context.api.q("/summary/set", {
      id: item.id ? item.id : null,
      tracker: tracker.id,
      description: item.description,
      data: this.state.formData,
      form: this.state.fields,
    });

    if (resultItem !== false) {
      this.context.toast("Изменения сохранены", "success");

      if (this.props.onFinish) {
        this.props.onFinish(item);
      }
      this.props.onClose();
    } else {
      this.context.toast("Не удалось сохранить изменения", "error");
    }
    this.setState({ pending: false });
  };

  render() {
    const { tracker } = this.props;
    const { pending, formData = {}, fields = [] } = this.state;

    return (
      <BsModal xl {...this.props} center>
        <Blocker spinnerFixed on={pending}>
          <h5>Суточный отчет</h5>
          <hr />

          {fields.length === 0 && (
            <DefaultNotFound
              message={
                <span>
                  Форма суточного отчета не найдена{" "}
                  {tracker.typecode && (
                    <span className="text-muted">({tracker.typecode})</span>
                  )}
                </span>
              }
            />
          )}
          {fields.length > 0 && (
            <Jsonform
              formData={formData}
              fields={fields}
              onChange={this.onFormChange}
            />
          )}

          <hr />
          <button onClick={this.save} className="btn btn-primary mr-2">
            Сохранить
          </button>
          <button className="btn btn-light" onClick={this.props.onClose}>
            Отмена
          </button>
        </Blocker>
      </BsModal>
    );
  }
}
